<template>
  <div v-scroll="handleScroll" :class="{ show: show }" class="PageNav">
    <nav class="section-nav">
      <scrollactive :offset="navOffset" active-class="active" tag="section">
        <a
          v-for="(item, index) in menuList"
          :key="index"
          :style="{ top: 50 * (menu.length - item.id) + 'px' }"
          :href="item.url"
          class="anchor-link scrollactive-item"
          @click="setOffset(item.offset)"
        >
          <v-tooltip :nudge-top="18" class="tooltip-wrap" color="primarydark" left>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ $t(item.name) }}</span>
            </template>
            <span class="tooltip">{{ $t(item.name) }}</span>
          </v-tooltip>
        </a>
      </scrollactive>
    </nav>
    <v-tooltip :nudge-top="25" color="primarydark" left>
      <template v-slot:activator="{ on }">
        <scrollactive tag="div">
          <v-btn fab class="fab anchor-link scrollactive-item" href="#home" v-on="on">
            <v-icon dark class="icon">mdi-arrow-up</v-icon>
          </v-btn>
        </scrollactive>
      </template>
      <span class="tooltip" v-t="'To Top'"></span>
    </v-tooltip>
  </div>
</template>

<style scoped lang="scss">
@import "./pagenav-style";
</style>

<script>
import { getMenuList } from "../Header/menu";
import navMenu from "../Header/menu";

export default {
  data: () => ({
    menu: navMenu,
    navOffset: 20,
    show: false,
    menuList: getMenuList(),
  }),
  methods: {
    handleScroll: function () {
      if (window.scrollY > 500) {
        return (this.show = true);
      }
      return (this.show = false);
    },
    setOffset: function (offset) {
      this.navOffset = offset;
    },
  },
};
</script>
